import {Locales} from '@netx/core-next/locales/utils/Locales';
import {KeywordType} from './constants';

export const KeywordTypeLabel: Record<KeywordType, string> = Locales(
	(i18n) => ({
		[KeywordType.MATCH_ALL_FRAGMENTS]: i18n('i18n.matchAllFragments'),
		[KeywordType.MATCH_ANY_FRAGMENT]: i18n('i18n.matchAnyFragment'),
		[KeywordType.MATCH_EXACTLY]: i18n('i18n.matchExactly'),
		[KeywordType.MATCH_EXACTLY_INCLUDING_DIACRITICAL_MARKS]: i18n(
			'i18n.matchExactlyIncludingDiacriticalMarks',
		),
		[KeywordType.MATCH_EXCLUDE]: i18n('i18n.matchExclude'),
		[KeywordType.MATCH_ALL_WHOLE_WORDS_AND]: i18n('i18n.matchAllWholeWordsAND'),
		[KeywordType.MATCH_ANY_WHOLE_WORDS_OR]: i18n('i18n.matchAnyWholeWordsOR'),
	}),
);
